import PropTypes from 'prop-types'
import { useEffect } from 'react'

import { analytics } from 'legacy/utils/analytics'

import { LoadTaken } from '../../LoadTaken/LoadTaken'
import {
  FullHeightStep,
  PanelSection,
  StepHeading,
  StepTitle,
  StepSubtitle,
  StepContent,
  StepFooter,
  ReasonsList,
  BigIconExclamation,
} from '../styles'

function UnavailableMessage({ isEligibilityIssue, lane }) {
  useEffect(() => {
    if (isEligibilityIssue) {
      analytics.tag(['Book Detailed Error Message'])
    }
  }, [isEligibilityIssue])
  return isEligibilityIssue ? (
    <FullHeightStep>
      <PanelSection>
        <StepHeading block>
          <BigIconExclamation />
          <StepTitle>Load unavailable</StepTitle>
          <StepSubtitle>
            This load is currently unavailable to you due to one or more of the following reasons:
          </StepSubtitle>
        </StepHeading>

        <StepContent>
          <ReasonsList>
            <li>Your insurance score could be under the required</li>
            <li>You don&apos;t meet the minimum requirements for this load</li>
            <li>You can&apos;t operate in those states</li>
          </ReasonsList>
        </StepContent>
      </PanelSection>
      <StepFooter>
        If you have any questions about this give us a call at <strong>(646) 887 6278</strong> or
        send an email to <a href="mailto:carrier@loadsmart.com">carrier@loadsmart.com</a>
      </StepFooter>
    </FullHeightStep>
  ) : (
    <PanelSection>
      <LoadTaken lane={lane} userIsLoggedIn />
    </PanelSection>
  )
}

UnavailableMessage.propTypes = {
  isEligibilityIssue: PropTypes.bool,
  lane: PropTypes.shape({
    origin: PropTypes.shape({
      description: PropTypes.string,
    }),
    destination: PropTypes.shape({
      description: PropTypes.string,
    }),
    weekdays: PropTypes.arrayOf(PropTypes.string),
    equipment_types: PropTypes.arrayOf(PropTypes.string),
    starts_at: PropTypes.string,
    expires_at: PropTypes.string,
  }),
}

UnavailableMessage.defaultProps = {
  isEligibilityIssue: false,
  lane: undefined,
}

export { UnavailableMessage }
